import { Action, createAction, props } from '@ngrx/store';

/**
 * Tipos de Acción para el Store de Autenticación
 */
export enum AuthActionTypes {
    LOGIN = '[Auth] Login',
    // LoginByToken = '[Authorization] LoginByToken',
    LOGIN_SUCCESS = '[Auth] Login Success',
    LOGIN_FAILURE = '[Auth] Login Failure',
    LOGOUT = '[Auth] Logout',
    SET_AUTH = '[Auth] Set Login',
    UPDATE_DATA = 'Update User Data'
}

export const LogIn = createAction(AuthActionTypes.LOGIN, props<{ user: any, account: any,company: any,permissions:any }>());
export const LogInSuccess = createAction(AuthActionTypes.LOGIN_SUCCESS, props<{ seguridad: any}>());
export const LogInFailure = createAction(AuthActionTypes.LOGIN_FAILURE, props<{ error: any }>());
export const LogOut = createAction(AuthActionTypes.LOGOUT);
export const SetAuth = createAction(AuthActionTypes.SET_AUTH, props<{ seguridad: any }>());
export const UpdateData = createAction(AuthActionTypes.UPDATE_DATA, props<{ seguridad: any }>());
export const ResetStore = createAction('[App] Reset Store');

